class UserJob {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }

  setData(data) {
    this.id = data.id;
    this.name = data.name;
    this.organizationId = data.organizationId;
  }

  toUpdate() {
    return {
      id: this.id,
      name: this.name,
    };
  }
}

export default UserJob;
